export enum ChatEventType {
    Connect = 'connect',
    Disconnect = 'disconnect',
    JoinChannel = 'joinChannel',
    NewMessage = 'newMessage',
    JoinNotificationChannel = 'joinNotificationChannel',
    NotificationReceived = 'notificationReceived',
    JoinContractChannel = 'joinContractChannel',
    ContractStatusUpdated = 'contractStatusUpdated'
}
